const messageReceivedAudioPath = `${process.env.NX_PUBLIC_DEPLOY_URL || '/'}assets/sounds/message-received.mp3`;
const incomingChatInitialAudioPath = `${process.env.NX_PUBLIC_DEPLOY_URL || '/'}assets/sounds/incoming-chat-initial.mp3`;
const incomingChatEverySecondAudioPath = `${process.env.NX_PUBLIC_DEPLOY_URL || '/'}assets/sounds/incoming-chat-second.mp3`;

export enum AudioType {
  MessageReceived = 'message-received',
  IncomingChatInitial = 'incoming-chat-initial',
  IncomingChatEverySecond = 'incoming-chat-every-second',
}

const audioFilePathMap: Record<AudioType, string> = {
  [AudioType.MessageReceived]: messageReceivedAudioPath,
  [AudioType.IncomingChatEverySecond]: incomingChatEverySecondAudioPath,
  [AudioType.IncomingChatInitial]: incomingChatInitialAudioPath,
};

const audios: Partial<Record<AudioType, HTMLAudioElement>> = {};

export const getAppAudio = (type: AudioType) => {
  if (!Object.keys(audios).includes(type)) {
    audios[type] = new Audio(audioFilePathMap[type]);
  }
  return {
    play: () => audios[type]?.play().catch((error) => console.error(error)),
  };
};
